import React from 'react';
import { UserIcon } from '../../UI/Icons';
import './MobileHeader.css';

interface MobileHeaderProps {
  onProfileClick: () => void;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({ onProfileClick }) => {
  return (
    <header className="mobile-header">
      <div className="mobile-header-content">
        <div className="mobile-header-spacer" />
        <button
          className="mobile-profile-button"
          onClick={onProfileClick}
          title="Профіль користувача"
        >
          <UserIcon size={24} />
        </button>
      </div>
    </header>
  );
};

export default MobileHeader;
